import { SWATCHES, type Theme, type TokenDef } from "@/data/config";
import { ColorField } from "@/components/color-field";
import { LogoControl } from "@/features/theming/logo-control";

/** A single editable theme token (color swatch or logo control). */
export function TokenControl({
  def,
  theme,
  onChange,
}: {
  def: TokenDef;
  theme: Theme;
  onChange: (key: string, value: string | null) => void;
}) {
  return (
    <div className="rounded-xl">
      <div className="mb-2.5">
        <div className="text-[13.5px] font-bold text-foreground">{def.label}</div>
        <div className="mt-px text-[11.5px] text-text-3">{def.hint}</div>
      </div>
      {def.kind === "color" ? (
        <ColorField
          value={(theme[def.id as keyof Theme] as string) ?? "#000000"}
          onChange={(v) => onChange(def.id, v)}
          swatches={SWATCHES}
        />
      ) : (
        <LogoControl theme={theme} onChange={onChange} />
      )}
    </div>
  );
}
